export const find =
  <T>(predicate: (value: T) => boolean) =>
  (array: T[]): T | undefined =>
    array.find(predicate)
